<div id="wrapper">
  <div class="d-flex flex-column" id="content-wrapper">
    <div class="container-fluid">
      <div class="ui-g align-justify">
        <div class="ui-g-12 form-main-body">
          <app-nav-steps></app-nav-steps>
        </div>
      </div>
      <div class="ui-g align-justify">
        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
          <app-location-form *ngIf="enableJurisdictionCheck"></app-location-form>
          <app-media-selection-form *ngIf="!enableJurisdictionCheck"></app-media-selection-form>
        </div>
      </div>
    </div>
  </div>
</div>





